module.exports = __webpack_public_path__ + "img/TM.cfd756b3.svg";